import { UserDataContext } from '@/contexts';
import { useContext } from 'react';

const useUserDataContext = () => {
  const context = useContext(UserDataContext);

  if (!context) {
    throw new Error('useUserDataContext must be wrapped by UserDataContextProvider');
  }

  return context;
};

export default useUserDataContext;